import { ICourse } from './course';

export interface IInvites {
  count: number;
  invitesList: IInvite[];
}

export interface IInvite {
  id: string;
  status: enStatusInvite;
  course: {
    id: number;
    author: ICourse['author'];
    customization: {
      avatar: string;
      new_avatar: string;
    };
    producer_id: number;
    subdomain: string;
    title: string;
  };
  hash: string;
}

export enum enStatusInvite {
  SENT = 'sent',
  PENDING = 'pending',
  CANCELED = 'canceled',
  ACCEPT = 'accept',
  ACCOUNTS_ERROR = 'accounts_error',
  CONTACT_CENTER_ERROR = 'contact_center_error',
  GENERIC_ERROR = 'generic_error',
  INVALID_EMAIL = 'invalid_email',
  GANESHA_ERROR = 'ganesha_error',
  REFUSED = 'refused'
}
